import { LICENSES } from "@/utils/license";
import { IntlShape } from "react-intl";
import {
  array,
  check,
  InferInput,
  minLength,
  nonEmpty,
  nullish,
  object,
  pipe,
  string,
  trim,
} from "valibot";
import { authorSchema } from "../DatasetVersionAuthorInput/schema";

export const schema = (intl: IntlShape) =>
  object({
    license: nullish(
      pipe(
        string(),
        nonEmpty(),
        trim(),
        check(
          (input) => LICENSES.some((license) => license === input),
          intl.formatMessage(
            { defaultMessage: "license must one of {licenses} " },
            { licenses: LICENSES.join(", ") },
          ),
        ),
      ),
    ),
    authors: nullish(pipe(array(authorSchema), minLength(1))),
  });

export type Schema = ReturnType<typeof schema>;
export type SchemaInput = InferInput<Schema>;
export type { AuthorSchemaInput } from "../DatasetVersionAuthorInput/schema";
